import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import GlobalButton from "../../../common/GlobalButton"; // Corrected import path
import LogsIconDesign from "../../../common/LogsIconDesign";
export default function LogButton({ policyData }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const fieldsToShow = [
    "ID",
    "Added_Time",
    "Modified_Time",
    "Modified_User",
    "Multi_Line",
  ];

  return (
    <>
      <LogsIconDesign
        size="small"
        variant="contained"
        onClick={handleOpen}
        sx={{ minWidth: 80, height: 36, px: 2, py: 0.5 }}
      />
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>Policy Data Logs</DialogTitle>
        <DialogContent>
          {policyData.length === 0 ? (
            <Typography color="text.secondary">
              No policy data available.
            </Typography>
          ) : (
            policyData.map((item) => (
              <div key={item.id} style={{ marginBottom: "20px" }}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Field
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Value
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {fieldsToShow.map((field) => (
                      <TableRow key={field}>
                        <TableCell>{field}</TableCell>
                        <TableCell>
                          {typeof item[field] === "string" &&
                          item[field].length > 100
                            ? `${item[field].substring(0, 100)}...` // Truncate long strings
                            : JSON.stringify(item[field], null, 2)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ))
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
